import * as tslib_1 from "tslib";
import { suggestionSelected } from '../actions/publicActions';
import { CLICK_ACTION_SOURCE } from '../searchConstants';
import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import * as React from 'react';
import highlightDisplayText, { dehighlightDisplayText, } from './suggestionsContextMenu/highlightDisplayText';
var styles = require('./SuggestionsContextMenu.scss');
var KeywordSuggestionMenuItem = /** @class */ (function (_super) {
    tslib_1.__extends(KeywordSuggestionMenuItem, _super);
    function KeywordSuggestionMenuItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KeywordSuggestionMenuItem.prototype.render = function () {
        var suggestion = this.props.suggestion;
        var highlightTextRegions = highlightDisplayText(suggestion.DisplayText);
        return (React.createElement("div", { className: styles.keywordSuggestion, key: suggestion.DisplayText, tabIndex: 0, 
            // VSO: 17221 We should change onMouseDown to onClick
            onMouseDown: function () {
                suggestionSelected(suggestion, CLICK_ACTION_SOURCE);
            }, title: dehighlightDisplayText(suggestion.DisplayText) },
            React.createElement(Icon, { className: styles.suggestionIcon, iconName: suggestion.Attributes && suggestion.Attributes.IsHistory
                    ? "History" /* History */
                    : "Search" /* Search */ }),
            highlightTextRegions.filter(function (e) { return e.text.length > 0; }).map(function (e) {
                var className = e.isHighlighted
                    ? styles.keywordMatchSuggestion
                    : styles.keywordNonMatchSuggestion;
                return React.createElement("div", { className: className }, e.text);
            })));
    };
    KeywordSuggestionMenuItem = tslib_1.__decorate([
        observer
    ], KeywordSuggestionMenuItem);
    return KeywordSuggestionMenuItem;
}(React.Component));
export default KeywordSuggestionMenuItem;
//# sourceMappingURL=KeywordSuggestionMenuItem.js.map